import featureToggles from '../sharedComponents/featureToggle'
// import ApiHandler from './ApiHandler'

export default {
  getFeatureToggles: () => featureToggles
}
